import { Box, Button, IconButton, styled } from '@mui/material';

export const ToolbarContainer = styled(Box)(() => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  gap: '2px',
  padding: '6px 8px',
  borderBottom: '1px solid #EAECF0',
  backgroundColor: '#FAFAFA',
}));

export const Divider = styled(Box)(() => ({
  width: '1px',
  height: '20px',
  backgroundColor: '#D9D9D9',
  margin: '0 6px',
}));

interface ToolbarButtonProps {
  selected?: boolean;
}

export const ToolbarButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<ToolbarButtonProps>(({ theme, selected }) => ({
  width: '28px',
  height: '28px',
  borderRadius: '6px',
  color: '#475467',

  '& span': {
    fontSize: '18px',
  },

  '&:hover': {
    backgroundColor: selected
      ? theme.palette.secondary.dark
      : `${theme.palette.secondary.main}26`,
  },

  ...(selected && {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
  }),
}));

export const LinkPopoverContent = styled(Box)(() => ({
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  padding: '12px',
}));

export const ApplyLinkButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  width: 'fit-content',
  whiteSpace: 'nowrap',
  padding: '6px 16px',
}));
